import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from '../components/ui/card';

const About = () => {
  const { language } = useLanguage();

  return (
    <div className="page-container min-h-screen py-16 bg-gradient-to-br from-white via-mint-50 to-blue-50">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-4xl">
          <div className="mb-12 text-center">
            <h1 className="mb-4 text-4xl font-bold text-slate-900 sm:text-5xl" data-testid="about-title">
              {language === 'ro' ? 'Despre financiallyfree.ro' : 'About financiallyfree.ro'}
            </h1>
          </div>

          <Card className="mb-8 border-0 shadow-lg">
            <CardContent className="p-8">
              {language === 'ro' ? (
                <div className="prose prose-lg max-w-none">
                  <h2>De ce existăm?</h2>
                  <p>
                    Simplu: pentru că ne-am săturat de guru-ii financiari care vând vise și scheme piramidale.
                    financiallyfree.ro e locul unde afli ce funcționează pe bune, fără bullshit.
                  </p>

                  <h2>Cine suntem, de fapt?</h2>
                  <p>
                    Suntem niște oameni normali cu peste 25 de ani de experiență combinată în investiții, side hustle-uri 
                    și tot ce ține de bani. Am făcut și noi greșeli (destule!), dar am învățat din ele.
                    Acum împărtășim totul—ce a mers și ce nu.
                  </p>

                  <h2>Ce găsești aici</h2>
                  <ul>
                    <li><strong>Articole pe bune</strong>: Ghiduri practice, fără povești de adormit copiii</li>
                    <li><strong>Produse digitale</strong>: Template-uri și strategii testate, nu teoretice</li>
                    <li><strong>Calculatoare gratuite</strong>: Ca să-ți faci socotelile simplu ca bună ziua</li>
                    <li><strong>AI Money Mentor</strong>: Un asistent care răspunde la orice întrebare despre bani, fără să te judece</li>
                  </ul>

                  <h2>Pentru cine e asta?</h2>
                  <p>
                    Pentru oameni normali care vor mai mult de la viață. Nu trebuie să fii geniu la matematică 
                    sau să ai un MBA. Trebuie doar să vrei să înveți și să faci ceva în plus.
                    Dacă ești aici, deja ești pe drumul cel bun. 💪
                  </p>

                  <h2>În ce credem</h2>
                  <ul>
                    <li><strong>Simplitate</strong>: Dacă nu-ți explică și bunica, nu e bine explicat</li>
                    <li><strong>Onestitate</strong>: Zero bullshit, doar ce funcționează</li>
                    <li><strong>Acțiune</strong>: Mai puțină teorie, mai multe rezultate</li>
                    <li><strong>Comunitate</strong>: Nu ești singur în asta. Hai în gașcă!</li>
                  </ul>
                </div>
              ) : (
                <div className="prose prose-lg max-w-none">
                  <h2>Our Mission</h2>
                  <p>
                    financiallyfree.ro is a project created to help normal people in Romania build their financial
                    freedom, step by step.
                  </p>

                  <h2>Who We Are</h2>
                  <p>
                    We're a team of experts with over 25 years of combined experience in financial freedom,
                    investments, and money education. We've helped thousands of people take control of their
                    finances and build a life free from money worries.
                  </p>

                  <h2>What We Offer</h2>
                  <ul>
                    <li><strong>Practical Articles</strong>: Guides on budgeting, saving, and side hustles</li>
                    <li><strong>Digital Products</strong>: Actionable templates, plans, and strategies</li>
                    <li><strong>Free Tools</strong>: Calculators for financial planning</li>
                    <li><strong>AI Money Mentor</strong>: Personal assistant for financial education</li>
                  </ul>

                  <h2>Who It's For</h2>
                  <p>
                    This project is for normal people who want to build a better life without depending solely
                    on a salary. You don't need to be a financial expert—just willing to learn and take action.
                  </p>

                  <h2>Our Values</h2>
                  <ul>
                    <li><strong>Simplicity</strong>: No complicated financial jargon</li>
                    <li><strong>Honesty</strong>: We share what actually works</li>
                    <li><strong>Action</strong>: Focus on practical steps, not just theory</li>
                    <li><strong>Community</strong>: We build together, not alone</li>
                  </ul>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default About;